import { render } from "./textInput.vue?vue&type=template&id=0b06b6f1&scoped=true"
import script from "./textInput.vue?vue&type=script&lang=js"
export * from "./textInput.vue?vue&type=script&lang=js"

import "./textInput.vue?vue&type=style&index=0&id=0b06b6f1&scoped=true&lang=css"

import exportComponent from "/Users/user/Desktop/Проекты/territory_transport/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b06b6f1"]])

export default __exports__